<template>
  <div>
    <b-row>
      <b-col
          md="6"
          xl="6"
      >
        <b-card-code title="Addressdaten" v-show="ad != null">
          <b-row>
            <b-col
                md="4"
                xl="4"
            >
              <b-form-group label="Kennnummer">
                <b-input-group>
                  <b-form-input
                      v-model="ad.AddressId"
                      ref="PickUpPassengerNumber"
                      size="sm"
                  />
                  <template #append>
                    <b-button

                        size="sm"
                    >
                      <feather-icon
                          size="14"
                          icon="SaveIcon"
                          class="mr-50"
                      />
                    </b-button>
                  </template>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
                md="8"
                xl="8"
            >
              <b-form-group
                  label="Name"
              >
                <b-form-input
                    v-model="ad.Contact.Name"
                    size="sm"
                />

              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col
                md="4"
                xl="4"
            >
              <b-form-group
                  label="Postleitzahl"
                  label-for="ZipCode"
              >
                <b-form-input
                    id="ZipCode"
                    v-model="ad.Address.ZipCode"
                    size="sm"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="4"
                xl="4"
            >
              <b-form-group
                  label="Ort"
                  label-for="Location"
              >
                <b-form-input
                    id="Location"
                    v-model="ad.Address.Location"
                    size="sm"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="4"
                xl="4"
            >
              <b-form-group
                  label="Ortsteil"
                  label-for="District"
              >
                <b-form-input
                    id="District"
                    v-model="ad.Address.District"
                    size="sm"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col
                md="12"
                xl="12"
            >
              <b-form-group
                  label="Adresse"
              >
                <b-form-input
                    @keyup="OpenPopover('pickupStreet')"
                    id="PickupAddressData-Street-popoverShow"
                    @blur.stop="ClosePopoverStreet()"
                    v-model="ad.Address.Street"
                    ref="PickupAddressStreet"
                    size="sm"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col
                md="4"
                xl="4"
            >
              <b-form-group
                  label="Telefon"
              >
                <b-form-input
                    id="District"
                    v-model="ad.Contact.Phone"
                    size="sm"
                />

              </b-form-group>
            </b-col>
            <b-col
                md="4"
                xl="4"
            >
              <b-form-group
                  label="Handy"
                  label-for="PassengerPhone2"
              >
                <b-form-input
                    id="PassengerPhone2"
                    v-model="ad.Contact.Phone2"
                    size="sm"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="4"
                xl="4"
            >
              <b-form-group
                  label="E-Mail"
                  label-for="PassengerEmail"
              >
                <b-form-input
                    class="index_passengeremail"
                    id="PassengerEmail"
                    v-model="ad.Contact.Email"
                    size="sm"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-code>
      </b-col>
      <b-col
          md="6"
          xl="6"
      >
        <b-card-code title="Rechnungskunde" v-show="customer != null">
          <b-row>
            <b-col
                md="4"
                xl="4"
            >
              <b-form-group label="Kennnummer">
                <b-input-group>
                  <b-form-input
                      v-model="ad.AddressId"
                      ref="PickUpPassengerNumber"
                      size="sm"
                  />
                  <template #append>
                    <b-button

                        size="sm"
                    >
                      <feather-icon
                          size="14"
                          icon="SaveIcon"
                          class="mr-50"
                      />
                    </b-button>
                  </template>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
                md="8"
                xl="8"
            >
              <b-form-group
                  label="Name"
              >
                <b-form-input
                    v-model="ad.Contact.Name"
                    size="sm"
                />

              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col
                md="4"
                xl="4"
            >
              <b-form-group
                  label="Postleitzahl"
                  label-for="ZipCode"
              >
                <b-form-input
                    id="ZipCode"
                    v-model="ad.Address.ZipCode"
                    size="sm"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="4"
                xl="4"
            >
              <b-form-group
                  label="Ort"
                  label-for="Location"
              >
                <b-form-input
                    id="Location"
                    v-model="ad.Address.Location"
                    size="sm"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="4"
                xl="4"
            >
              <b-form-group
                  label="Ortsteil"
                  label-for="District"
              >
                <b-form-input
                    id="District"
                    v-model="ad.Address.District"
                    size="sm"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col
                md="12"
                xl="12"
            >
              <b-form-group
                  label="Adresse"
              >
                <b-form-input
                    @keyup="OpenPopover('pickupStreet')"
                    id="PickupAddressData-Street-popoverShow"
                    @blur.stop="ClosePopoverStreet()"
                    v-model="ad.Address.Street"
                    ref="PickupAddressStreet"
                    size="sm"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col
                md="4"
                xl="4"
            >
              <b-form-group
                  label="Telefon"
              >
                <b-form-input
                    id="District"
                    v-model="ad.Contact.Phone"
                    size="sm"
                />

              </b-form-group>
            </b-col>
            <b-col
                md="4"
                xl="4"
            >
              <b-form-group
                  label="Handy"
                  label-for="PassengerPhone2"
              >
                <b-form-input
                    id="PassengerPhone2"
                    v-model="ad.Contact.Phone2"
                    size="sm"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="4"
                xl="4"
            >
              <b-form-group
                  label="E-Mail"
                  label-for="PassengerEmail"
              >
                <b-form-input
                    class="index_passengeremail"
                    id="PassengerEmail"
                    v-model="ad.Contact.Email"
                    size="sm"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-code>
      </b-col>
    </b-row>
    <b-card-code title="Voucher">
      <b-row>
        <b-col
            md="12"
            xl="12"
        >
          <b-table
              striped
              hover
              responsive
              :items="items"
              :fields="fields"
              @row-clicked="clickVoucher"
          >
            <template #cell(Vid)="data">{{ data.item.Vid }}
              <feather-icon
                  v-show="data.item.BillNumber != ''"
                  icon="LockIcon"
                  size="12"
              />
              <b-badge
                  v-show="data.item.Canceled != null"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  v-b-tooltip.hover.v-primary
                  :title="(data.item.Canceled + ' ('+data.item.CanceledUser+')')"
                  variant="warning"
              >Storniert
              </b-badge>
            </template>

            <template #cell(PickUpAddress)="data">
              <br>{{ data.item.PickUpAddressContact.Name }}
              <br>{{ data.item.PickUpAddress.ZipCode }} {{ data.item.PickUpAddress.Location }}
              <br>{{ data.item.PickUpAddress.Street }}
            </template>
            <template #cell(DestinationAddress)="data">
              <br>{{ data.item.DestinationAddressContact.Name }}
              <br>{{ data.item.DestinationAddress.ZipCode }} {{ data.item.DestinationAddress.Location }}
              <br>{{ data.item.DestinationAddress.Street }}
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-card-code>
  </div>
</template>

<script>

import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BDropdown, BDropdownItem, VBTooltip
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'Call',
  components: {
    BCardCode,
    BDropdown,
    BDropdownItem,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      fields: [
        {
          key: 'Vid',
          label: 'V-Data',
        },
        {
          key: 'PickupTime',
          label: 'Abholung',
        },
        {
          key: 'Passengers',
          label: 'Personen',
        },
        {
          key: 'Customer',
          label: 'Kunde',
        },
        {
          key: 'PickUpAddress',
          label: 'Adresse',
        },
        {
          key: 'DestinationAddress',
          label: 'Ziel',
        },
        {
          key: 'Drivers',
          label: 'Fahrer',
        },
      ],
      items: [{
        Costomer: 'Wird geladen....'
      }],
      ad: null,
      customer: null,

    }
  },
  computed: {},
  mounted() {
    this.$nextTick(() => {
      document.title = 'Anruf: 00000'
    })
    this.Load()
  },
  methods: {
    clickVoucher(record, index) {
      this.$router.push({
        name: 'VoucherMask',
        params: { id: record.Vid }
      })
    },
    formatDate(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          },
      )}`
    },
    Load() {
      this.items = []
      this.$http.get('/sip/last/incoming')
          .then(resp => {
            if (resp.data.success) {
              resp.data.sipCall.Vouchers.forEach(i => {
                this.items.push(i)
              })
              this.ad = resp.data.sipCall.AddressTemplate
              this.customer = resp.data.sipCall.Customer
              console.log(this.ad)
            }

          })
          .catch(err => {
            console.error(err)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'CheckIcon',
                text: err,
                variant: 'danger',
              },
            })
          })
    },
  },
}
</script>
